import { createIcon } from '../createIcon';
import { ReactComponent as IconTimesCircle } from '../svg/times-circle.svg';

export default createIcon(IconTimesCircle);
